import { SYM_PROP_LINKING, SYM_ROOT_PROP } from "../../enum/Symbol"
import useMarkParentLinking, { getParentLinking, isContainParentLinking } from "./useMarkParentLinking";
import { getRootProps, useMarkRootProp } from "../chain/store/useStoreRoot";

// const storeCopy = use

const useCloneObject = (original, target = {}) => {
    target = Object.assign(target, original);

    if (isContainParentLinking(original)) {
        useMarkParentLinking(target, getParentLinking(original));
    }
    const root = getRootProps(original);
    if (root) {
        useMarkRootProp(target, root);
    }
    return target;
}

export default useCloneObject